import { useState, useEffect } from 'react';
import { Outlines } from '../types';

export function usePdfOutline(pdfDoc: any) {
    const [outlines, setOutlines] = useState<Outlines>([]);

    useEffect(() => {
        if (!pdfDoc) {
            setOutlines([]);
            return;
        }

        async function outlinesPretreatment(items: Outlines) {
            if (!items) return;
            for (const outline of items) {
                if (outline.dest) {
                    try {
                        const index = await pdfDoc.getPageIndex(outline.dest[0]);
                        outline.pageNum = index + 1;
                    } catch (e) {
                        console.warn('Failed to resolve outline dest', e);
                    }
                }
                if (outline.items?.length > 0) {
                    await outlinesPretreatment(outline.items);
                }
            }
        }

        pdfDoc
            .getOutline?.()
            .then(async (fetchedOutlines: Outlines) => {
                if (fetchedOutlines) {
                    await outlinesPretreatment(fetchedOutlines);
                    setOutlines(fetchedOutlines);
                } else {
                    setOutlines([]);
                }
            })
            .catch((_err: any) => {
                setOutlines([]);
            });
    }, [pdfDoc]);

    return outlines;
}
